import { ApiProperty } from '@nestjs/swagger';

export class PusherAuthenticateOutputModel {
  @ApiProperty()
  public readonly auth!: string | null;

  @ApiProperty()
  public readonly user_data!: string | null;

  constructor(object: object | null) {
    Object.assign(this, object);
  }
}
